import Session from "supertokens-auth-react/recipe/session";
import EmailPassword from "supertokens-auth-react/recipe/emailpassword";
import EmailVerification from "supertokens-auth-react/recipe/emailverification";
import Passwordless from "supertokens-auth-react/recipe/passwordless";
import EmailVerificationSend from "./views/components/auth/EmailVerificationSend";
import EmailVerificationAction from "./views/components/auth/EmailVerificationAction";

export const SuperTokensConfig = {
    appInfo: {
        appName: "Assignify",
        apiDomain: process.env.REACT_APP_BACKEND_API_URL || "http://localhost:5000",
        websiteDomain: process.env.REACT_APP_FRONTEND_URL || "http://localhost:3000",
    },
    disableAuthRoute: true,
    recipeList: [
        EmailPassword.init({
            signUpFeature: {
                formFields: [
                    {
                        id: "firstName",
                        name: "firstName",
                        label: "First Name",
                        placeholder: "Enter your first name",
                    },
                    {
                        id: "lastName",
                        name: "lastName",
                        label: "Last Name",
                        placeholder: "Enter your last name",
                    },
                ],
            },
        }),
        EmailVerification.init({
            mode: "REQUIRED",
            override: {
                components: {
                    EmailVerificationSendVerifyEmail: ({ ...props }) => {
                        return <EmailVerificationSend {...props} />;
                    },
                    EmailVerificationVerifyEmailLink: ({ ...props }) => {
                        return <EmailVerificationAction {...props} />;
                    },
                },
            },
        }),
        Passwordless.init({
            contactMethod: "EMAIL",
        }),
        Session.init(),
        // Session.init({
        //     tokenTransferMethod: "header",
        //     isInIframe: true
        // }),
    ],
};
